// extracted by mini-css-extract-plugin
var _1 = "r0BazQL08h";
var _2 = "C0hnCdJDr6";
var _3 = "ooWYsiux4a";
export { _1 as "danger", _2 as "disabled", _3 as "root" }
